import { type PayloadAction } from '@reduxjs/toolkit';
import { keyBy, get } from 'lodash';

import { createSlice } from '@/lib/redux/createSlice';
import { AccountsService } from '@/lib/services/accounts';

import { initialState } from './initialState';
import type { IAccount } from '@enl/type-definitions';

const slice = createSlice({
  name: 'accounts',
  initialState: initialState,
  reducers: (create) => {
    return {
      getAccounts: create.asyncThunk<IAccount[], void, { rejectValue: string }>(
        async () => {
          const accounts = await AccountsService.getAccounts();
          return accounts;
        },
        {
          pending: (state) => {
            state.loading = true;
          },
          options: {
            condition: (_, api) => {
              const x = api.getState();
              const isLoading = get(x, 'accounts.loading', false);
              return !isLoading;
            },
          },
          rejected: (state) => {
            state.loading = false;
          },
          fulfilled: (state, action: PayloadAction<IAccount[]>) => {
            state.loading = false;
            state.accounts = keyBy(action.payload, '_id');
          },
        }
      ),
    };
  },
});

export default slice;
